























import Vue from "vue";
import { Component } from "vue-property-decorator";
import Dropdown from "./dropdown.vue";
import { RendererFactory } from "survey-core";
import { PopupUtils } from "src/utils/popup";

@Component
export class DropdownSelect extends Dropdown {
  public click(event: any) {
    PopupUtils.updatePopupWidthBeforeShow(this.question.popupModel, event);
  }
}

Vue.component("sv-dropdown-select", DropdownSelect);

RendererFactory.Instance.registerRenderer("dropdown", "select", "sv-dropdown-select");

export default DropdownSelect;
